export class AppLayoutsFullheightComponent {
  isFullHeight() {
    return true;
  }
}
